"use client";

import { Button } from "../ui/button";
import { Heart, Gift } from "lucide-react";

export default function JoinTheJourney() {
  const handleBecomeMember = () => {
    // Navigate to external membership page
    window.open("https://membership.ljpr.in/", "_blank");
  };

  const handleMakeDonation = () => {
    // Navigate to external donation page
    window.open("https://membership.ljpr.in/?type=donor", "_blank");
  };

  return (
    <section className="relative min-h-screen md:h-screen overflow-hidden p-0 m-0">
      {/* Main background with smooth gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-950 via-slate-900 to-black"></div>

      {/* Subtle theme color accent - responsive */}
      <div className="absolute inset-0 md:left-auto md:right-0 md:w-1/2 bg-gradient-to-l from-logoBlue/10 via-logoRed/10 to-transparent md:from-logoBlue/5 md:via-logoRed/5"></div>

      {/* Shirt image as separate element - responsive for all devices */}
      <div className="hidden md:block absolute left-0 bottom-0 md:top-0 h-1/2 md:h-full w-full md:w-1/2 bg-[url('/images/journey-shirt-3.png')] bg-contain bg-center md:bg-left-bottom lg:bg-left bg-no-repeat z-10 opacity-30 md:opacity-100"></div>

      {/* Content Container */}
      <div className="relative z-20 min-h-screen md:h-screen flex items-center p-0">
        <div className="w-full m-0 p-0">
          <div className="grid grid-cols-1 gap-0 h-full">
            {/* Left side is now handled by background image */}

            {/* Content Side */}
            <div className="relative z-20 text-white space-y-6 lg:space-y-8 mx-auto md:ml-auto md:mr-0 w-full max-w-lg md:max-w-none md:w-2/3 lg:w-1/2 px-6 sm:px-8 md:pr-8 md:pl-0 lg:pr-12 flex items-center py-8 md:py-0">
              <div className="w-full">
                {/* Main Heading */}
                <div className="space-y-4 sm:space-y-5">
                  <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black tracking-tight leading-tight md:leading-none">
                    <span className="text-white whitespace-nowrap relative">
                      JOIN THE JOURNEY
                      <span className="absolute -bottom-2 left-0 w-1/3 h-1 bg-logoRed"></span>
                    </span>
                  </h1>

                  <p className="text-lg sm:text-xl lg:text-2xl text-gray-200 font-light">
                    Be the change you want to see.
                  </p>

                  <div className="flex items-center space-x-2 text-2xl sm:text-3xl lg:text-4xl font-bold">
                    <span className="text-white">JOIN</span>
                    <span className="bg-logoRed text-white px-3 py-0.5 rounded-lg border border-white/20">
                      LJPR
                    </span>
                  </div>
                </div>

                {/* Description */}
                <div className="space-y-4 max-w-xl">
                  <p className="text-base sm:text-lg text-gray-200 leading-relaxed">
                    LJPR is devoutly committed to building a strong and
                    developed India which is unimaginable without the trust and
                    the unflinching support of the people of India.
                  </p>

                  <p className="text-base sm:text-lg text-gray-200 leading-relaxed">
                    Join us and be part of the unprecedented transformation that
                    is changing the lives of all sections of society for better.
                    Together, let's build 'Ek Bharat, Shreshtha Bharat' and
                    witness the rise of New India under the charismatic
                    leadership of PM Shri Narendra Modi.
                  </p>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-6 flex-wrap justify-center md:justify-start">
                  <Button
                    onClick={handleBecomeMember}
                    className="bg-pink-600 hover:bg-pink-700 text-white font-bold py-4 sm:py-6 px-6 sm:px-8 text-sm sm:text-lg rounded-sm transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 sm:gap-3 min-h-[60px] sm:min-h-[80px] uppercase tracking-wide"
                  >
                    <Heart className="w-4 h-4 sm:w-6 sm:h-6" />
                    <span className="text-center leading-tight">
                      <span className="sm:hidden">BECOME MEMBER</span>
                      <span className="hidden sm:block">
                        BECOME A<br />
                        MEMBER
                      </span>
                    </span>
                  </Button>

                  <Button
                    onClick={handleMakeDonation}
                    className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 sm:py-6 px-6 sm:px-8 text-sm sm:text-lg rounded-sm transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 sm:gap-3 min-h-[60px] sm:min-h-[80px] uppercase tracking-wide"
                  >
                    <Gift className="w-4 h-4 sm:w-6 sm:h-6" />
                    <span className="text-center leading-tight">
                      <span className="sm:hidden">MAKE DONATION</span>
                      <span className="hidden sm:block">
                        MAKE A<br />
                        DONATION
                      </span>
                    </span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements with theme colors - responsive */}
      <div className="absolute bottom-0 left-0 md:left-auto md:right-0 w-full md:w-1/2 h-32 bg-gradient-to-t from-logoBlue/10 to-transparent pointer-events-none"></div>
      <div className="absolute top-0 right-0 w-20 sm:w-32 h-20 sm:h-32 bg-gradient-to-bl from-logoRed/10 to-transparent pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-20 sm:w-32 h-20 sm:h-32 bg-gradient-to-tl from-logoGreen/10 to-transparent pointer-events-none"></div>
    </section>
  );
}
